import { countCaseByKeyList } from "../../api";

const programme = {
  namespaced: true,
  state: () => ({
    countKeyList: [],
    keyword: ["营销", "推广", "招商", "运营", "定位", "活动", "规划", "商业"],
  }),

  getters: {
    countKeyList: (state) => state.countKeyList,
  },

  mutations: {
    SET_COUNT_KEY_LIST(state, list) {
      state.countKeyList = list;
    },
  },

  actions: {
    async countCaseByKey({ commit, state }) {
      const response = await countCaseByKeyList(state.keyword);
      commit("SET_COUNT_KEY_LIST", response.data);
    },
  },
};

export default programme;
